import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, Label, Spinner } from 'reactstrap';
import moment from 'moment';
import { Col, Row, Button as Btn, Input } from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Modal, Radio, RadioGroup, Rating, Select, TextField, TextareaAutosize, Typography } from '@mui/material';
import { Edit } from '@material-ui/icons';
import oikosApi from '../../../services/oikos';
import powerAppsApi from '../../../services/powerapps';
import qs from 'qs';
import DadosContaAPagar from './DadosContaAPagar';
import DadosFavorecidoPj from './DadosFavorecidoPj';
import DadosFavorecidoPf from './DadosFavorecidoPf';
import Dropzone from 'react-dropzone';
import AddFilesNoForm from '../../../components/Template/Files/AddFilesNoForm';
import { saveAnexosContaAPagar, getLinkDocumentoDeCobranca, getLinkNotaFiscal, getLinkComprovante, selectValues, parseCurrencyToNumber, notifyBordero, notifyExceedingBordero, taskManager, sendMail, sendEmailToNotify, printStandardEmail } from '../../../utils/fc';
import currencyFormatter from '../../../utils/currencyFormatter';
import DatePicker from 'react-datepicker';
import SearchableSelect from 'react-select'
import MaskedInput from '../../../components/Template/Input/MaskedInput';
import ModalFormAddFavBordero from '../../../components/Modals/ModalFormAddFavBordero/ModalFormAddFavBordero';
import ModalFormEdicaoFavBordero from '../../../components/Modals/ModalFormEdicaoFavBordero/ModalFormEdicaoFavBordero';
import { notifyError, notifySuccess } from '../../../utils/notify';
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { linkProducaoVM, linkOikosLabPaginas, linkOikosLabVM, linkProducaoPaginas, getOikosFileUrl } from '../../../utils/linksOikos/link';
import PdfPreviewPanel from './PdfPreviewPanel';
import ModalConfirmacao from '../../../components/Modals/ModalConfirmacao/ModalConfirmacao';
import ModalOrcamentoExcedido from './ModalOrcamentoExcedido';

const ModalEdicaoContaAPagar = ( props ) => {

  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [isLoadingRow, setIsLoadingRow] = useState(false);
  const [isLoadingCadastra, setIsLoadingCadastra] = useState(false);
  const [favs, setFavs] = useState('');
  const [isPf, setIsPf] = useState(props.data.bdro_favTab === 'pf' ? true : false);
  const [selectedFav, setSelectedFav] = useState({});
  const [todasAsContas, setTodasAsContas] = useState([]);
  const [selectedConta, setSelectedConta] = useState({});
  const [todasAsCategorias, setTodasAsCategorias] = useState([]);
  const [pagadores, setPagadores] = useState([]);
  const [pagador, setPagador] = useState({});
  const [selectedCategoria, setSelectedCategoria] = useState({});
  const [orcItems, setOrcItems] = useState([]);
  const [selectedOrcItem, setSelectedOrcItem] = useState({}); // To store the selected option
  const [faturaComposta, setFaturaComposta] = useState(Number(props.data?.movTp_id) === 6);
  const [valor, setValor] = useState(String(props.data.bdro_vlr));
  const [desc, setDesc] = useState(props.data.bdro_desc);
  const [dataVenc, setDataVenc] = useState(props.data.bdro_dtVenc ? moment(props.data.bdro_dtVenc).toDate() : null)
  const [dataQuit, setDataQuit] = useState(props.data.bdro_dtQuit ? moment(props.data.bdro_dtQuit).toDate() : null)
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [orcamentoInfoMes, setOrcamentoInfoMes] = useState({})
  const [emptyValues, setEmptyValues] = useState([]);
  const [linkDocumentoDeCobranca, setLinkDocumentoDeCobranca] = useState(null);
  const [linkNotaFiscal, setLinkNotaFiscal] = useState(null);
  const [linkComprovante, setLinkComprovante] = useState(null);
  const [documentoDeCobrancaFiles, setDocumentoDeCobrancaFiles] = useState([]);
  const [notaFiscalFiles, setNotaFiscalFiles] = useState([]);
  const [comprovantePagamentoFiles, setComprovantePagamentoFiles] = useState([]);
  const [favChanged, setFavChanged] = useState(false);
  const [codBarras, setCodBarras] = useState(props.data.bdro_codBarras);
  const [dispNF, setDispNF] = useState(Number(props.data.bdro_dispNF) === 1);
  const [dispDocCobranca, setDispDocCobranca] = useState(Number(props.data.bdro_dispDocCobranca) === 1);
  const [linkedContrFornId, setLinkedContrFornId] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewLabel, setPreviewLabel] = useState('');
  const [favRefreshKey, setFavRefreshKey] = useState(0);
  const [kaminoId, setKaminoId] = useState(props.data.kamino_id || null);
  const [clearKaminoOpen, setClearKaminoOpen] = useState(false);
  const [clearingKamino, setClearingKamino] = useState(false);
  const [baixandoComprovante, setBaixandoComprovante] = useState(false);
  const skipSaldoRef = useRef(false);

  const linkASerUsadoVM = linkProducaoVM;
  const linkASerUsadoPaginas = linkProducaoPaginas;

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleOpenErrorModal = () => setOpenErrorModal(true);
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
    setEmptyValues([]);
  };

  useEffect(() => {
    setKaminoId(props.data.kamino_id || null);
  }, [props.data.kamino_id, props.data.bdro_id]);

  const handleClearKaminoId = async () => {
    if (Number(props.user?.perm_id) !== 1 || !props.data?.bdro_id) return;
    setClearingKamino(true);
    try {
      const res = await oikosApi.post('/', {
        action: 'update',
        table: 'bdro',
        data: {
          bdro_id: props.data.bdro_id,
          kamino_id: null,
          bdro_usuarioMod: props.user.pf_id,
        },
      });
      if (res?.ok === false || (res?.status && res.status >= 400)) {
        notifyError('Não foi possível limpar o identificador Kamino.');
        return;
      }
      setKaminoId(null);
      if (typeof props.getOneBdroRecord === 'function') {
        await props.getOneBdroRecord(props.data.bdro_id);
      }
      notifySuccess('Identificador Kamino removido deste borderô.');
      setClearKaminoOpen(false);
    } catch (e) {
      notifyError('Não foi possível limpar o identificador Kamino.');
    } finally {
      setClearingKamino(false);
    }
  };

  const baixarComprovanteKamino = async () => {
    if (!props.data?.bdro_id || baixandoComprovante) return;
    setBaixandoComprovante(true);
    try {
      const res = await powerAppsApi.post('/', {
        acao: 'kamino_baixar_comprovante_bdro',
        bdro_id: props.data.bdro_id,
      }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        },
      });
      let data = res?.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (err) { data = null; }
      }
      if (!data?.ok || !data?.caminho) {
        notifyError(data?.message || 'A Kamino não devolveu o comprovante.');
        return;
      }
      const links = await getLinkComprovante(props.data.bdro_id);
      const lista = Array.isArray(links) && links.length ? links : [data.caminho];
      setLinkComprovante(lista);
      const path = lista[lista.length - 1];
      setPreviewUrl(getOikosFileUrl(path));
      setPreviewLabel('Comprovante');
      if (data.data_quit) setDataQuit(moment(data.data_quit).toDate());
      if (typeof props.getOneBdroRecord === 'function') {
        await props.getOneBdroRecord(props.data.bdro_id);
      }
      notifySuccess(data.ja_existia ? 'O comprovante já estava salvo.' : 'Comprovante baixado da Kamino.');
    } catch (err) {
      notifyError('Não foi possível obter o comprovante.');
    } finally {
      setBaixandoComprovante(false);
    }
  };

  const handleChangeCodBarras = (e) => {
    const inputValue = e.target.value;
    const digitsOnly = inputValue.replace(/\D/g, '');

    const length = digitsOnly.length;

    const startsWith = digitsOnly.substring(0, 3);

    const isBoleto = length === 47 && /^\d{3}9/.test(digitsOnly);  // Bank boleto
    const isConcessionaria = length === 48 && digitsOnly.startsWith('8');  // Utility or tax
    const isEAN = length === 13 || length === 14;  // Product barcodes

    const isCodigoDeBarras = isBoleto || isConcessionaria || isEAN;

    if (isCodigoDeBarras) {
      setCodBarras(String(digitsOnly));
    } else {
      setCodBarras(String(inputValue));
    }
  };

  useEffect(() => {
    const fetchLinkedContrFornId = async () => {
      if (props.data.bdro_tabRef !== 'contrFornEvento' || !props.data.bdro_tabId) {
        setLinkedContrFornId(null);
        return;
      }

      try {
        const response = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'contrFornEvento',
          fields: {
            contrForn_id: 'contrForn_id',
          },
          data: {
            contrFornEvento_id: props.data.bdro_tabId,
          },
        })}`);

        setLinkedContrFornId(response.data?.[0]?.contrForn_id || null);
      } catch (error) {
        console.error('Erro ao buscar contrato vinculado ao bordero:', error);
        setLinkedContrFornId(null);
      }
    };

    fetchLinkedContrFornId();
  }, [props.data.bdro_tabRef, props.data.bdro_tabId]);

  const cadastrarPendente = async () => {

    setIsStatusLoading(false)

    setIsLoadingCadastra(true);

    if (props.proj_orcRubrId) {
      const bdroBody = {
        action: 'update',
        table: 'bdro',
        data: {
          bdro_id: props.data.bdro_id,
          bdro_dtVenc: moment(dataVenc).format('YYYY-MM-DD'),
          bdro_vlr: Number(valor),
          bdro_usuarioCria: props.user.pf_id,
          bdro_usuarioMod: props.user.pf_id,
          bdro_favTab: isPf ? 'pf' : 'pj',
          bdro_favId: selectedFav.value,
          orcItem_id: selectedOrcItem.value,
          bdro_desc: desc,
          bdro_orcPend: 1,
          bdro_codBarras: codBarras,
          bdro_dispNF: dispNF ? 1 : 0,
          bdro_dispDocCobranca: dispDocCobranca ? 1 : 0,
        },
      };

      const bdroCreated = await oikosApi.post('/', bdroBody);

      if ((documentoDeCobrancaFiles.length > 0 || linkDocumentoDeCobranca.length > 0) &&
        (notaFiscalFiles.length > 0 || linkNotaFiscal.length > 0)) {
        const arrayAnexos = [
          { tipo: 'documento de cobranca', arquivo: documentoDeCobrancaFiles[0]?.data },
          { tipo: 'nota fiscal', arquivo: notaFiscalFiles[0]?.data },
          { tipo: 'comprovante', arquivo: comprovantePagamentoFiles[0]?.data },
        ]
        console.log(arrayAnexos);
        const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
        console.log(arrayAnexosFiltrado);
        console.log(bdroCreated.data[0]);
        await saveAnexosContaAPagar(arrayAnexosFiltrado, bdroCreated.data[0]);
      }

      await props.getOneBdroRecord(bdroCreated.data[0].bdro_id);
    } else {

      const bdroBody = {
        action: 'update',
        table: 'bdro',
        data: {
          bdro_id: props.data.bdro_id,
          bdro_dtVenc: moment(dataVenc).format('YYYY-MM-DD'),
          ...(dataQuit ? { bdro_dtQuit: ((moment(dataQuit).format('YYYY-MM-DD') === "Data inválida") || (moment(dataQuit).format('YYYY-MM-DD') === "Invalid date")) ? undefined : moment(dataQuit).format('YYYY-MM-DD') } : {}),
          bdro_vlr: Number(valor),
          conta_id: selectedConta.value,
          bdro_usuarioCria: props.user.pf_id,
          bdro_usuarioMod: props.user.pf_id,
          bdro_favTab: isPf ? 'pf' : 'pj',
          bdro_favId: selectedFav.value,
          orcItem_id: selectedOrcItem.value,
          bdro_desc: desc,
          bdro_orcPend: 1,
          bdro_pagador: pagador?.value,
          bdro_codBarras: codBarras,
          bdro_dispNF: dispNF ? 1 : 0,
          bdro_dispDocCobranca: dispDocCobranca ? 1 : 0,
        },
      };

      const bdroCreated = await oikosApi.post('/', bdroBody);

      if ((documentoDeCobrancaFiles.length > 0 || linkDocumentoDeCobranca.length > 0) &&
        (notaFiscalFiles.length > 0 || linkNotaFiscal.length > 0)) {
        const arrayAnexos = [
          { tipo: 'documento de cobranca', arquivo: documentoDeCobrancaFiles[0]?.data },
          { tipo: 'nota fiscal', arquivo: notaFiscalFiles[0]?.data },
          { tipo: 'comprovante', arquivo: comprovantePagamentoFiles[0]?.data },
        ]
        console.log(arrayAnexos);
        const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
        console.log(arrayAnexosFiltrado);
        console.log(bdroCreated.data[0]);
        await saveAnexosContaAPagar(arrayAnexosFiltrado, bdroCreated.data[0]);
      }

      await props.getOneBdroRecord(bdroCreated.data[0].bdro_id);
    }

    //await taskManager(selectedOrcItem.orcItem_desc);

    // await notifyExceedingBordero({desc: desc, valor: valor, orcamentoInfoMes: orcamentoInfoMes});

    setIsLoadingCadastra(false);

    handleClose()
    handleCloseModal()


  }

  const convertValueToText = (value) => {
    switch (value) {
      case 'bdro_dtVenc':
        return 'Data de Vencimento';
      case 'bdro_dtQuit':
        return 'Data de Quitação';
      case 'conta_id':
        return 'Conta';
      case 'orcItem_id':
          return 'Item orçamentário';
      case 'bdro_favId':
        return 'Favorecido';
      case 'bdro_desc':
        return 'Descrição';
      case 'categ_id':
        return 'Categoria';
      case 'documento de cobranca':
        return 'Documento de cobrança';
      case 'nota fiscal':
        return 'Nota Fiscal';
      case 'bdro_pagador':
        return 'Pagador';
      case 'bdro_codBarras':
        return 'Código de barras';
    }
  }

  const getFavs = async (pfTrue) => {
    try {
      if (!pfTrue) {
        const res = await selectValues('pj', 'pj_id', 'pj_nomefanta');

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setFavs(sortedFavs);

        return sortedFavs;

      } else {
        const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao');

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setFavs(sortedFavs);

        return sortedFavs;

      }
    } catch (error) {
      console.error("Failed to fetch product details:", error);
    }
  };

  const handleFavSaved = async (favId) => {
    await getFavs(isPf)
    setFavRefreshKey((k) => k + 1)
    if (selectedFav?.value === favId || !selectedFav?.value) {
      // força selectedFav a manter seleção após refresh da lista
      const list = await getFavs(isPf)
      const found = (list || []).find((f) => f.value === favId)
      if (found) setSelectedFav(found)
    }
  }

    const getOrcItems = async (categ_id) => {
    try {

      let dataOrcItems = {
        orcItem_ativo: 1,
        categ_id: categ_id
      }

      if (props.proj_orcRubrId) {
        const in_txt = `!IN!(SELECT orcItem_id FROM orcItem WHERE orcRubr_id IN (SELECT id_oikos FROM viewOrcRubr_taxonomia2 WHERE nivel3_id = ${props.proj_orcRubrId}))`;
        dataOrcItems = {
          orcItem_ativo: 1,
          orcItem_id: in_txt,
          categ_id: categ_id,
        }
      }

      const queryString = `/?${qs.stringify({
        action: 'get',
        table: 'orcItem',
        fields: {
          orcItem_id: 'value',
          "(CONCAT((SELECT rubrica FROM viewOrcRubr_taxonomia2 WHERE viewOrcRubr_taxonomia2.id_oikos = orcItem.orcRubr_id),'::',orcItem_desc))": 'label',
        },
        data: dataOrcItems,
        order: 'label'
      })}`;

      const resp = await oikosApi.get(queryString);

      const parsedArray = resp.data.map((caminho) => {
        return { value: caminho.value, label: caminho.label, categ_id: caminho.categ_id, orcItem_desc: caminho.orcItem_desc}
      },[])

      setOrcItems(parsedArray);

    } catch (error) {
      console.error("Failed to fetch product details:", error);
    }
  };

  const setInitialOrcItem = async (categ_id) => {

    let dataOrcItems = {
      orcItem_ativo: 1,
      categ_id: categ_id
    }

    if (props.proj_orcRubrId) {
      const in_txt = `!IN!(SELECT orcItem_id FROM orcItem WHERE orcRubr_id IN (SELECT id_oikos FROM viewOrcRubr_taxonomia2 WHERE nivel3_id = ${props.proj_orcRubrId}))`;
      dataOrcItems = {
        orcItem_ativo: 1,
        orcItem_id: in_txt,
        categ_id: categ_id,
      }
    }

    const queryString = `/?${qs.stringify({
      action: 'get',
      table: 'orcItem',
      fields: {
        orcItem_id: 'value',
        "(CONCAT((SELECT rubrica FROM viewOrcRubr_taxonomia2 WHERE viewOrcRubr_taxonomia2.id_oikos = orcItem.orcRubr_id),'::',orcItem_desc))": 'label',
      },
      data: dataOrcItems,
      order: 'label'
    })}`;

    const resp = await oikosApi.get(queryString);

    setSelectedOrcItem(resp.data.find(orcItem => orcItem.orcItem_id === props.data.orcItem_id));
  }

  const getContas = async () => {

    const resTodasAsContas = await selectValues('conta', 'conta_id', 'conta_nome', {contaTp_id: 1});

    const sortedTodasAsContas = (resTodasAsContas).sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    })

    setTodasAsContas(sortedTodasAsContas);

    setSelectedConta(resTodasAsContas.find(conta => conta.value === props.data.conta_id));
  };

  const getPagadores = async () => {

    const resPagador1 = await selectValues('pj', 'pj_id', 'pj_nomefanta', {pj_id: 1});
    const resPagador2 = await selectValues('pj', 'pj_id', 'pj_nomefanta', {pj_id: 2});

    const resPagadores = [...resPagador1, ...resPagador2]

    console.log(resPagadores)

    setPagadores(resPagadores);

    setPagador(resPagadores.find(conta => conta.value === props.data.bdro_pagador));
  };

  const getCategorias = async () => {

    let dataCategorias = {
      categ_ativo: 1,
    }

    if (props.proj_orcRubrId) {
      const in_txt = `!IN!(SELECT categ_id FROM viewRubr_OrcItem WHERE nivel3_id = ${props.proj_orcRubrId})`;
      dataCategorias = {
        categ_ativo: 1,
        categ_id: in_txt
      }
    }

    const resTodasAsCategorias = await selectValues('categ', 'categ_id', 'categ_nome', dataCategorias);

    const sortedTodasAsCategorias = (resTodasAsCategorias).sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    })

    setTodasAsCategorias(sortedTodasAsCategorias);

    const categSelected = sortedTodasAsCategorias.find(categ => categ.value === props.data.categ_id);

    if (!props.data.categ_id || !props.data.orcItem_id) {
      console.log(props.data)
      setSelectedCategoria({});
      setInitialOrcItem({})
      //getOrcItems(categSelected.value)
      return
    }

    setSelectedCategoria(categSelected);
    if(categSelected.value) {
      setInitialOrcItem(categSelected.value)
    }
    getOrcItems(categSelected.value)
  };

  const handleClickOpen = async () => {
    setIsLoadingRow(true);
    setOpen(true);

    await getPagadores();
    await getCategorias();
    await setSelectedFav({});
    const promise = getFavs(isPf)
    await getContas();
    if (props.data.bdro_favId) {
      promise.then(result => {
        setSelectedFav(result.find(fav => fav.value === props.data.bdro_favId));
      });
    }

    setIsLoadingRow(false);

  };

  const handleClose = () => {
    setOpen(false);
    setPreviewUrl(null);
    setPreviewLabel('');
  };



  /*
  const verifySaldo = async () => {
    const bdro_id = props.data.bdro_id

    const queryString = `/?${qs.stringify({
      action: 'get',
      table: 'orcDot',
      fields: {
        [`(SELECT SUM(orcDot_valor) FROM orcDot WHERE orcItem_id = ${selectedOrcItem.value} AND orcDot_ativo = 1 AND DATE_FORMAT(orcDot_data, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "emOrcDot",
        [`(SELECT SUM(bdro_vlr) FROM bdro WHERE orcItem_id = ${selectedOrcItem.value} AND bdro_ativo = 1 AND bdro_id != ${bdro_id} AND DATE_FORMAT(bdro_dtVenc, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "jaNoBordero",
      },
      data: {
        orcItem_id: selectedOrcItem.value,
        orcDot_data: moment(dataVenc).format('YYYY-MM'),
        orcDot_ativo: 1,
      }
    })}`;

    const checkSaldo = await oikosApi.get(queryString);

    if (checkSaldo.data.length === 0) {
      console.log("Sem orcDot para este orcItem")
      return
    } else {
      if (!checkSaldo.data[0].jaNoBordero) {
        checkSaldo.data[0].jaNoBordero = 0;
      }
    }

    console.log(checkSaldo)
  }
  */

  const camposFatura = () => (
    faturaComposta
      ? { movTp_id: 6, orcItem_id: null }
      : {
          orcItem_id: selectedOrcItem?.value,
          ...(Number(props.data?.movTp_id) === 6 ? { movTp_id: null } : {}),
        }
  );

  const handleSubmit = async () => {
    const skipSaldo = skipSaldoRef.current
    skipSaldoRef.current = false

    const bdro_id = props.data.bdro_id

    if(props.proj_orcRubrId) {
      const bdroBody = {
        action: 'update',
        table: 'bdro',
        data: {
          bdro_id: props.data.bdro_id,
          bdro_dtVenc: moment(dataVenc).format('YYYY-MM-DD'),
          bdro_vlr: valor,
          bdro_usuarioCria: props.user.pf_id,
          bdro_usuarioMod: props.user.pf_id,
          bdro_favTab: isPf ? 'pf' : 'pj',
          bdro_favId: selectedFav?.value,
          ...camposFatura(),
          bdro_desc: desc,
          bdro_orcPend: 0,
          bdro_codBarras: codBarras,
          bdro_dispNF: dispNF ? 1 : 0,
          bdro_dispDocCobranca: dispDocCobranca ? 1 : 0,
        },
      }

      for (const key in bdroBody.data) {
        if (
            ((!bdroBody.data[key] && bdroBody.data[key] != 0) ||
            bdroBody.data[key] === 'Data inválida') &&
            key !== "bdro_codBarras" &&
            key !== "bdro_dtQuit" &&
            key !== "bdro_dtQuit" &&
            key !== "bdro_orcPend" &&
            (props.user.perm_id === 1 && (!bdroBody.data[key]) && ((key === "bdro_pagador") || (key === "conta_id")))
          )
        {
          console.log(`${key} is falsy`);
          emptyValues.push(`${key}`);
        }
      }

      if (documentoDeCobrancaFiles.length <= 0 && linkDocumentoDeCobranca.length <= 0 && !bdroBody.data['bdro_dtQuit'] && !dispDocCobranca) {
        emptyValues.push(`documento de cobranca`);
      }

      if (notaFiscalFiles.length <= 0 && linkNotaFiscal.length <= 0 && !bdroBody.data['bdro_dtQuit'] && !dispNF) {
        emptyValues.push(`nota fiscal`);
      }

      if (!faturaComposta && Object.keys(selectedCategoria).length === 0) {
        console.log(`categoria is falsy`);
        emptyValues.push(`categ_id`);
      }

      if (emptyValues.length > 0) {
        handleOpenErrorModal();
        return;
      }

      if (!faturaComposta) {
      const queryString = `/?${qs.stringify({
        action: 'get',
        table: 'orcDot',
        fields: {
          [`(SELECT SUM(orcDot_valor) FROM orcDot WHERE orcItem_id = ${selectedOrcItem.value} AND orcDot_ativo = 1 AND DATE_FORMAT(orcDot_data, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "emOrcDot",
          [`(SELECT SUM(bdro_vlr) FROM bdro WHERE orcItem_id = ${selectedOrcItem.value} AND bdro_ativo = 1 AND bdro_id != ${bdro_id} AND DATE_FORMAT(bdro_dtVenc, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "jaNoBordero",
        },
        data: {
          orcItem_id: selectedOrcItem.value,
          orcDot_data: moment(dataVenc).format('YYYY-MM'),
          orcDot_ativo: 1,
        }
      })}`;

      const checkSaldo = await oikosApi.get(queryString);

      if (checkSaldo.data.length === 0) {
        setOrcamentoInfoMes({ emOrcDot: 0, jaNoBordero: 0 })
        if (!skipSaldo) {
          handleOpenModal()
          return
        }
      } else {
        if (!checkSaldo.data[0].jaNoBordero) {
          checkSaldo.data[0].jaNoBordero = 0;
        }
      }

      console.log(valor)

      if (checkSaldo.data.length > 0) {
        setOrcamentoInfoMes(checkSaldo.data[0]);
        console.log(checkSaldo.data[0].emOrcDot - Number(valor) - checkSaldo.data[0].jaNoBordero);

        const tolerancia = -0.01;

        if (!skipSaldo && (checkSaldo.data[0].emOrcDot - Number(valor) - checkSaldo.data[0].jaNoBordero) <= tolerancia) {
          handleOpenModal()
          return;
        }
      }

      }
      const bdroCreated = await oikosApi.post('/', bdroBody)

      if ((documentoDeCobrancaFiles.length > 0 || linkDocumentoDeCobranca.length > 0) &&
      (notaFiscalFiles.length > 0 || linkNotaFiscal.length > 0)) {
        const arrayAnexos = [
          { tipo: 'documento de cobranca', arquivo: documentoDeCobrancaFiles[0]?.data },
          { tipo: 'nota fiscal', arquivo: notaFiscalFiles[0]?.data },
          { tipo: 'comprovante', arquivo: comprovantePagamentoFiles[0]?.data },
        ]
        const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
        console.log(arrayAnexosFiltrado);
        await saveAnexosContaAPagar(arrayAnexosFiltrado, props.data);
      }
      await props.getOneBdroRecord(bdroCreated.data[0].bdro_id);
    }

    else {
      const bdroBody = {
        action: 'update',
        table: 'bdro',
        data: {
          bdro_id: props.data.bdro_id,
          bdro_dtVenc: moment(dataVenc).format('YYYY-MM-DD'),
          ...(dataQuit ? { bdro_dtQuit: ((moment(dataQuit).format('YYYY-MM-DD') === "Data inválida") || (moment(dataQuit).format('YYYY-MM-DD') === "Invalid date")) ? undefined : moment(dataQuit).format('YYYY-MM-DD') } : {}),
          bdro_vlr: valor,
          conta_id: selectedConta?.value,
          bdro_usuarioCria: props.user.pf_id,
          bdro_usuarioMod: props.user.pf_id,
          bdro_favTab: isPf ? 'pf' : 'pj',
          bdro_favId: selectedFav?.value,
          ...camposFatura(),
          bdro_desc: desc,
          bdro_orcPend: 0,
          bdro_pagador: pagador?.value,
          bdro_codBarras: codBarras,
          bdro_dispNF: dispNF ? 1 : 0,
          bdro_dispDocCobranca: dispDocCobranca ? 1 : 0,
        },
      }

      for (const key in bdroBody.data) {
        if (
            ((!bdroBody.data[key] && bdroBody.data[key] != 0) ||
            bdroBody.data[key] === 'Data inválida') &&
            key !== "bdro_codBarras" &&
            key !== "bdro_dtQuit" &&
            key !== "bdro_dtQuit" &&
            key !== "bdro_orcPend" &&
            (props.user.perm_id === 1 && (!bdroBody.data[key]) && ((key === "bdro_pagador") || (key === "conta_id")))
          )
        {
          console.log(`${key} is falsy`);
          emptyValues.push(`${key}`);
        }
      }

      if (documentoDeCobrancaFiles.length <= 0 && linkDocumentoDeCobranca.length <= 0 && !bdroBody.data['bdro_dtQuit'] && !dispDocCobranca) {
        emptyValues.push(`documento de cobranca`);
      }

      if (notaFiscalFiles.length <= 0 && linkNotaFiscal.length <= 0 && !bdroBody.data['bdro_dtQuit'] && !dispNF) {
        emptyValues.push(`nota fiscal`);
      }

      if (!faturaComposta && Object.keys(selectedCategoria).length === 0) {
        console.log(`categoria is falsy`);
        emptyValues.push(`categ_id`);
      }

      if (emptyValues.length > 0) {
        handleOpenErrorModal();
        return;
      }

      if (!faturaComposta) {
      const queryString = `/?${qs.stringify({
        action: 'get',
        table: 'orcDot',
        fields: {
          [`(SELECT SUM(orcDot_valor) FROM orcDot WHERE orcItem_id = ${selectedOrcItem.value} AND orcDot_ativo = 1 AND DATE_FORMAT(orcDot_data, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "emOrcDot",
          [`(SELECT SUM(bdro_vlr) FROM bdro WHERE orcItem_id = ${selectedOrcItem.value} AND bdro_ativo = 1 AND bdro_id != ${bdro_id} AND DATE_FORMAT(bdro_dtVenc, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "jaNoBordero",
        },
        data: {
          orcItem_id: selectedOrcItem.value,
          orcDot_data: moment(dataVenc).format('YYYY-MM'),
          orcDot_ativo: 1,
        }
      })}`;

      const checkSaldo = await oikosApi.get(queryString);

      if (checkSaldo.data.length === 0) {
        setOrcamentoInfoMes({ emOrcDot: 0, jaNoBordero: 0 })
        if (!skipSaldo) {
          handleOpenModal()
          return
        }
      } else {
        if (!checkSaldo.data[0].jaNoBordero) {
          checkSaldo.data[0].jaNoBordero = 0;
        }
      }

      console.log(valor)

      if (checkSaldo.data.length > 0) {
        setOrcamentoInfoMes(checkSaldo.data[0]);
        console.log(checkSaldo.data[0].emOrcDot - Number(valor) - checkSaldo.data[0].jaNoBordero);

        const tolerancia = -0.01;

        if (!skipSaldo && (checkSaldo.data[0].emOrcDot - Number(valor) - checkSaldo.data[0].jaNoBordero) <= tolerancia) {
          handleOpenModal()
          return;
        }
      }

      }
      const bdroCreated = await oikosApi.post('/', bdroBody)

      if ((documentoDeCobrancaFiles.length > 0 || linkDocumentoDeCobranca.length > 0) &&
      (notaFiscalFiles.length > 0 || linkNotaFiscal.length > 0)) {
        const arrayAnexos = [
          { tipo: 'documento de cobranca', arquivo: documentoDeCobrancaFiles[0]?.data },
          { tipo: 'nota fiscal', arquivo: notaFiscalFiles[0]?.data },
          { tipo: 'comprovante', arquivo: comprovantePagamentoFiles[0]?.data },
        ]
        const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
        console.log(arrayAnexosFiltrado);
        await saveAnexosContaAPagar(arrayAnexosFiltrado, props.data);
      }
      await props.getOneBdroRecord(bdroCreated.data[0].bdro_id);
    }

    //props.preloading();

    //handleClose();
  };

  const handleAprovarSuplementacao = async () => {
    skipSaldoRef.current = true
    handleCloseModal()
    setIsStatusLoading(true)
    setIsLoadingCadastra(true)
    try {
      await handleSubmit()
    } finally {
      setIsStatusLoading(false)
      setIsLoadingCadastra(false)
    }
  }

  const handleSelectChangeOrcItem = (e) => {
    const selected = orcItems.find((orcamentoItem) => {if (orcamentoItem && e) return orcamentoItem.value === e.value});
    if (selected) {
      setSelectedOrcItem(selected); // Update with the full pj object
    }
  };

  const handleSelectChangeConta = (e) => {
    const selected = todasAsContas.find((conta) => {if (conta && e) return conta.value === e.value});
    if (selected) {
      setSelectedConta(selected); // Update with the full pj object
    }
  };

  const handleSelectChangePagador = (e) => {
    const selected = pagadores.find((pagador) => {if (pagador && e) return pagador.value === e.value});
    if (selected) {
      setPagador(selected); // Update with the full pj object
    }
  };

  const handleSelectChangeCategorias = (e) => {
    const selected = todasAsCategorias.find((categoria) => {if (categoria && e) return categoria.value === e.value});
    if (selected) {
      setSelectedCategoria(selected); // Update with the full pj object
      getOrcItems(selected.value);
    }
    setSelectedOrcItem({});
  };

  const handleSendToBank = async () => {

    setIsStatusLoading(true);

    const bdroBody = {
      action: 'update',
      table: 'bdro',
      data: {
        bdro_id: props.data.bdro_id,
        bdro_dtVenc: moment(dataVenc).format('YYYY-MM-DD'),
        ...(dataQuit ? { bdro_dtQuit: ((moment(dataQuit).format('YYYY-MM-DD') === "Data inválida") || (moment(dataQuit).format('YYYY-MM-DD') === "Invalid date")) ? undefined : moment(dataQuit).format('YYYY-MM-DD') } : {}),
        bdro_vlr: valor,
        conta_id: selectedConta?.value,
        bdro_usuarioCria: props.user.pf_id,
        bdro_usuarioMod: props.user.pf_id,
        bdro_favTab: isPf ? 'pf' : 'pj',
        bdro_favId: selectedFav?.value,
        ...camposFatura(),
        bdro_desc: desc,
        bdro_orcPend: 0,
        bdro_pagador: pagador?.value,
        bdro_codBarras: codBarras,
        bdro_dispNF: dispNF ? 1 : 0,
        bdro_dispDocCobranca: dispDocCobranca ? 1 : 0,
      },
    }

    for (const key in bdroBody.data) {
      if (
        ((key !== "bdro_dtQuit" || key !== "bdro_orcPend") && (!bdroBody.data[key] && bdroBody.data[key] != 0) ||
        bdroBody.data[key] === 'Data inválida') &&
        key !== "bdro_codBarras" &&
        !(faturaComposta && key === "orcItem_id")
      )
      {
        console.log(`${key} is falsy`);
        emptyValues.push(`${key}`);
      }
    }

    if (documentoDeCobrancaFiles.length <= 0 && linkDocumentoDeCobranca.length <= 0 && !dispDocCobranca) {
      emptyValues.push(`documento de cobranca`);
    }

    if (notaFiscalFiles.length <= 0 && linkNotaFiscal.length <= 0 && !dispNF) {
      emptyValues.push(`nota fiscal`);
    }

    if (emptyValues.length > 0) {
      handleOpenErrorModal();
      setIsStatusLoading(false);
      return;
    }

    const bdroCreated = await oikosApi.post('/', bdroBody);

    const kaminoBody = {
      acao: 'kamino_salvar_pgto',
      id: props.data.bdro_id,
    }

    console.log(kaminoBody);

    const res = await powerAppsApi.post('/', kaminoBody, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    });

    console.log(res);

    if (res.status === 200) {
      notifySuccess('Informações enviadas para o banco!');
    }

    setIsStatusLoading(false);

  }

  if (isLoadingRow) {
    return (
      <Spinner/>
    )
  }
  /*
  if (databaseError) {
    return (
      <span style={{fontSize: '12px'}}>Problema DataBase</span>
    )
  }
  */

  function getAddContractUrl(orcItem_id) {
    return `${linkASerUsadoPaginas}meusfornecedores?${qs.stringify({
      openAddContractModal: 1,
      ...(orcItem_id && { orcItem_id }),
    })}`;
  }

  function funcaoEmailPara(orcItem_desc, orcItem_id) {
    return printStandardEmail(`<span>Favor criar o contrato para o item orçamentário ${orcItem_desc}. ${props.data.proj_nome ? 'Projeto: ' + props.data.proj_nome : ''} <a target="_blank" href="${getAddContractUrl(orcItem_id)}">Clique aqui para ir para a tela de contratos</a></span>`)
  }

  return (
    <>
      <Button
        variant=""
        style={props.trigger ? {
          padding: 0,
          minWidth: 0,
          textTransform: 'none',
          textAlign: 'left',
          justifyContent: 'flex-start',
          background: 'transparent',
          boxShadow: 'none',
        } : undefined}
        onClick={async () => {
        handleClickOpen();
        const linkDocumentoDeCobrancaResultado = await getLinkDocumentoDeCobranca(props.data.bdro_id);
        console.log(linkDocumentoDeCobrancaResultado);
        setLinkDocumentoDeCobranca(linkDocumentoDeCobrancaResultado);
        const linkNotaFiscalResultado = await getLinkNotaFiscal(props.data.bdro_id);
        setLinkNotaFiscal(linkNotaFiscalResultado);
        const linkComprovanteResultado = await getLinkComprovante(props.data.bdro_id);
        setLinkComprovante(linkComprovanteResultado);
        // Preferir o anexo mais recente de cada tipo (API costuma devolver do mais antigo ao mais novo).
        const newestPath = (arr) => (Array.isArray(arr) && arr.length ? arr[arr.length - 1] : null);
        const cobPath = newestPath(linkDocumentoDeCobrancaResultado);
        const nfPath = newestPath(linkNotaFiscalResultado);
        const compPath = newestPath(linkComprovanteResultado);
        const firstPreview = cobPath
          ? { url: getOikosFileUrl(cobPath), label: 'Documento de cobrança' }
          : nfPath
            ? { url: getOikosFileUrl(nfPath), label: 'Nota fiscal' }
            : compPath
              ? { url: getOikosFileUrl(compPath), label: 'Comprovante' }
              : null;
        setPreviewUrl(firstPreview?.url || null);
        setPreviewLabel(firstPreview?.label || '');
        }}>
        {props.trigger || <Edit style={{fontSize: "20px"}}/>}
      </Button>
      {!(favs === '') && todasAsContas.length > 0 &&
        <Dialog
          fullWidth
          maxWidth={false}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              margin: 'auto',
              width: '1200px',
              maxWidth: '96vw',
              maxHeight: '92vh',
            },
            component: 'form',
            onSubmit: async (event) => {
                setIsStatusLoading(true)
                event.preventDefault();
                await handleSubmit();
                setIsStatusLoading(false)
            },
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{ py: 1.25, px: 2.5, borderBottom: '1px solid #e5e7eb' }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <Typography component="span" sx={{ fontWeight: 700, fontSize: 16 }}>
                Conta a pagar
              </Typography>
              <Typography component="span" sx={{ fontSize: 12, color: '#64748b' }}>
                Kamino: <strong>{kaminoId ? kaminoId : 'Sem identificador'}</strong>
                {Number(props.user?.perm_id) === 1 && kaminoId ? (
                  <Btn
                    type="button"
                    color="link"
                    size="sm"
                    className="p-0 ml-2"
                    style={{ fontSize: 12, verticalAlign: 'baseline' }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setClearKaminoOpen(true);
                    }}
                  >
                    Limpar
                  </Btn>
                ) : null}
              </Typography>
            </div>
          </DialogTitle>

          {props.data.bdro_tabRef === 'contrFornEvento' ? (
            <div
              className="d-flex flex-fill justify-content-between align-items-center px-3 py-2"
              style={{ background: '#f8fafc', borderBottom: '1px solid #e5e7eb', fontSize: 12 }}
            >
              <div className="d-flex flex-column">
                <span>Parcela: <strong>{props.data.bdro_tabId ? props.data.bdro_tabId : 'Sem identificador'}</strong></span>
                {linkedContrFornId ? (
                  <a target="_blank" rel="noopener noreferrer" href={`https://oikos.ecoss.is/oikos-client/meusfornecedores?contrFornId=${linkedContrFornId}`}>
                    Ir para o contrato <strong>{linkedContrFornId}</strong>
                  </a>
                ) : (
                  <span>Contrato vinculado: <strong>Carregando...</strong></span>
                )}
              </div>
              <div className="d-flex flex-column text-right">
                {new Date(props.data.contrForn_dtVigFim).getTime() >= new Date().getTime() ? (
                  <span>Contrato vigente (fim: {moment(props.data.contrForn_dtVigFim).format('DD/MM/YYYY')})</span>
                ) : props.data.contrForn_dtVigFim ? (
                  <span>Contrato não vigente (fim: {moment(props.data.contrForn_dtVigFim).format('DD/MM/YYYY')})</span>
                ) : null}
                {Number(props.data.contrForn_soma_parcelas) && Number(props.data.contrForn_parcelas_batem_vlrGlobal) ? (
                  <span>Soma das parcelas = valor global</span>
                ) : props.data.contrForn_id ? (
                  <span>Soma das parcelas ≠ valor global</span>
                ) : null}
              </div>
            </div>
          ) : (
            <div
              className="d-flex flex-fill justify-content-between align-items-center px-3 py-2"
              style={{ background: '#f8fafc', borderBottom: '1px solid #e5e7eb', fontSize: 12 }}
            >
              <div className="d-flex flex-column">
                <span>Item sem contrato</span>
                {props.data.orcItem_pf_nomeExibicao ? (
                  <a
                    href="#"
                    onClick={async (e) => {
                      e.preventDefault();
                      const sended = await sendEmailToNotify(
                        props.data.orcItem_pf_emailProf,
                        `${props.data.proj_nome ? props.data.proj_nome + ' - ' : ''}Criação do contrato para o item orçamentário ${props.data.orcItem_desc}`,
                        funcaoEmailPara(props.data.orcItem_desc, props.data.orcItem_id),
                      );
                      if (sended) notifySuccess(`Email enviado para ${props.data.orcItem_pf_nomeExibicao}`);
                      else notifyError(`Falha ao enviar email para ${props.data.orcItem_pf_nomeExibicao}`);
                    }}
                  >
                    Enviar e-mail para {props.data.orcItem_pf_nomeExibicao}
                  </a>
                ) : (
                  <span>Sem contato do responsável pelo item orçamentário</span>
                )}
              </div>
            </div>
          )}

          <DialogContent sx={{ p: 2, overflow: 'hidden' }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1.05fr 0.95fr',
                gap: 16,
                minHeight: 540,
                maxHeight: 'calc(92vh - 190px)',
              }}
            >
              {/* Coluna formulário */}
              <div style={{ overflowY: 'auto', paddingRight: 4 }}>
                <Typography sx={{ fontWeight: 700, fontSize: 13, mb: 1, color: '#0f172a' }}>
                  Dados da conta
                </Typography>

                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  label="Descrição"
                  size="small"
                  margin="dense"
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                />

                <div className="d-flex flex-row" style={{ gap: 10, marginTop: 4 }}>
                  <FormControl size="small" style={{ flex: 1 }}>
                    <InputLabel shrink sx={{ backgroundColor: 'white', px: 0.5 }}>Valor</InputLabel>
                    <MaskedInput
                      mask="R$ num"
                      unmask
                      inputRef={(el) => { const inputVlrGlobal = el }}
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 1000000000,
                        },
                      }}
                      lazy={false}
                      value={valor}
                      onAccept={(value) => setValor(value)}
                    />
                  </FormControl>
                  {props.user.perm_id === 1 && (
                    <FormControl size="small" style={{ flex: 1.2 }}>
                      <InputLabel shrink sx={{ backgroundColor: 'white', px: 0.5 }}>Conta</InputLabel>
                      <SearchableSelect
                        classNamePrefix="select2-selection"
                        placeholder="Selecionar..."
                        isClearable
                        isSearchable
                        options={todasAsContas}
                        onChange={handleSelectChangeConta}
                        value={selectedConta}
                        styles={{
                                control: (base) => ({ ...base, minHeight: 32, height: 32, fontSize: 13 }),
                                valueContainer: (base) => ({ ...base, padding: '0 6px', height: 32 }),
                                indicatorsContainer: (base) => ({ ...base, height: 32 }),
                                input: (base) => ({ ...base, margin: 0, padding: 0 }),
                                menu: (base) => ({ ...base, zIndex: 5 }),
                              }}
                      />
                    </FormControl>
                  )}
                  {!faturaComposta && (
                  <FormControl size="small" style={{ flex: 1.2 }}>
                    <InputLabel shrink sx={{ backgroundColor: 'white', px: 0.5 }}>Categoria</InputLabel>
                    <SearchableSelect
                      classNamePrefix="select2-selection"
                      placeholder="Selecionar..."
                      isClearable
                      isSearchable
                      options={todasAsCategorias}
                      onChange={handleSelectChangeCategorias}
                      value={selectedCategoria}
                      styles={{
                                control: (base) => ({ ...base, minHeight: 32, height: 32, fontSize: 13 }),
                                valueContainer: (base) => ({ ...base, padding: '0 6px', height: 32 }),
                                indicatorsContainer: (base) => ({ ...base, height: 32 }),
                                input: (base) => ({ ...base, margin: 0, padding: 0 }),
                                menu: (base) => ({ ...base, zIndex: 5 }),
                              }}
                    />
                  </FormControl>
                  )}
                </div>

                <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8, marginBottom: 0, fontSize: 13, cursor: 'pointer', width: 'fit-content' }}>
                  <input
                    type="checkbox"
                    checked={faturaComposta}
                    onChange={(e) => setFaturaComposta(e.target.checked)}
                    style={{ width: 16, height: 16, margin: 0, flexShrink: 0, accentColor: '#1976d2' }}
                  />
                  Pagamento de fatura composta
                </label>

                {!faturaComposta && selectedCategoria && (
                  <FormControl fullWidth size="small" style={{ marginTop: 8 }}>
                    <InputLabel shrink sx={{ backgroundColor: 'white', px: 0.5 }}>Item orçamentário</InputLabel>
                    <SearchableSelect
                      classNamePrefix="select2-selection"
                      placeholder="Selecionar..."
                      isClearable
                      isSearchable
                      options={orcItems}
                      onChange={handleSelectChangeOrcItem}
                      value={selectedOrcItem}
                      styles={{
                                control: (base) => ({ ...base, minHeight: 32, height: 32, fontSize: 13 }),
                                valueContainer: (base) => ({ ...base, padding: '0 6px', height: 32 }),
                                indicatorsContainer: (base) => ({ ...base, height: 32 }),
                                input: (base) => ({ ...base, margin: 0, padding: 0 }),
                                menu: (base) => ({ ...base, zIndex: 5 }),
                              }}
                    />
                  </FormControl>
                )}

                <div className="d-flex flex-row align-items-end" style={{ gap: 10, marginTop: 8 }}>
                  <div style={{ flex: 1 }}>
                    <Label className="mb-1" style={{ fontSize: 12 }}>Vencimento</Label>
                    <DatePicker
                      placeholderText="__/__/_____"
                      locale="pt-BR"
                      className="form-control form-control-sm"
                      dateFormat="dd/MM/yyyy"
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      selected={dataVenc}
                      dropdownMode="select"
                      onChange={(date) => setDataVenc(date)}
                    />
                  </div>
                  {props.user.perm_id === 1 && (
                    <>
                      <div style={{ flex: 1 }}>
                        <Label className="mb-1" style={{ fontSize: 12 }}>Quitação</Label>
                        <DatePicker
                          placeholderText="__/__/_____"
                          locale="pt-BR"
                          className="form-control form-control-sm"
                          dateFormat="dd/MM/yyyy"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          selected={dataQuit}
                          dropdownMode="select"
                          onChange={(date) => setDataQuit(date)}
                        />
                      </div>
                      <div style={{ flex: 1.3 }}>
                        <Label className="mb-1" style={{ fontSize: 12 }}>Pagador</Label>
                        <SearchableSelect
                          classNamePrefix="select"
                          placeholder="Selecionar..."
                          isClearable
                          isSearchable
                          options={pagadores}
                          onChange={handleSelectChangePagador}
                          value={pagador}
                          styles={{
                                control: (base) => ({ ...base, minHeight: 32, height: 32, fontSize: 13 }),
                                valueContainer: (base) => ({ ...base, padding: '0 6px', height: 32 }),
                                indicatorsContainer: (base) => ({ ...base, height: 32 }),
                                input: (base) => ({ ...base, margin: 0, padding: 0 }),
                                menu: (base) => ({ ...base, zIndex: 5 }),
                              }}
                        />
                      </div>
                    </>
                  )}
                </div>

                <FormControl fullWidth size="small" style={{ marginTop: 8 }}>
                  <InputLabel shrink sx={{ backgroundColor: 'white', px: 0.5 }}>Código de barras</InputLabel>
                  <Input
                    type="text"
                    bsSize="sm"
                    value={String(codBarras)}
                    onChange={(e) => handleChangeCodBarras(e)}
                  />
                </FormControl>

                <div className="d-flex align-items-center justify-content-between" style={{ marginTop: 14, marginBottom: 4 }}>
                  <Typography sx={{ fontWeight: 700, fontSize: 13, color: '#0f172a' }}>
                    Favorecido
                  </Typography>
                  <div className="d-flex align-items-center" style={{ gap: 4 }}>
                    <ModalFormAddFavBordero
                      getFavs={getFavs}
                      isPf={isPf}
                      preloading={props.preloading}
                      setSelectedFav={setSelectedFav}
                      anexos={[
                        ...(documentoDeCobrancaFiles.length
                          ? documentoDeCobrancaFiles
                          : (Array.isArray(linkDocumentoDeCobranca) && linkDocumentoDeCobranca.length
                            ? [{ url: getOikosFileUrl(linkDocumentoDeCobranca[linkDocumentoDeCobranca.length - 1]) }]
                            : [])),
                        ...(notaFiscalFiles.length
                          ? notaFiscalFiles
                          : (Array.isArray(linkNotaFiscal) && linkNotaFiscal.length
                            ? [{ url: getOikosFileUrl(linkNotaFiscal[linkNotaFiscal.length - 1]) }]
                            : [])),
                      ]}
                    />
                    {selectedFav && Object.keys(selectedFav).length > 0 && (
                      <ModalFormEdicaoFavBordero getFavs={getFavs} isPf={isPf} preloading={props.preloading} fav={selectedFav} setSelectedFav={setSelectedFav} onFavSaved={handleFavSaved}/>
                    )}
                  </div>
                </div>

                <FormControl size="small">
                  <RadioGroup
                    row
                    name="radio-buttons-group"
                    onChange={(e) => {
                      setIsPf(JSON.parse(e.target.value));
                      getFavs(JSON.parse(e.target.value));
                      setSelectedFav({})
                    }}
                  >
                    <FormControlLabel control={<Radio size="small" value="true" />} label="PF" checked={isPf === true} />
                    <FormControlLabel control={<Radio size="small" value="false" />} label="PJ" checked={isPf === false} />
                  </RadioGroup>
                </FormControl>

                {(!isPf && favs !== '') ? (
                  <DadosFavorecidoPj {...props} favs={favs} selectedFav={selectedFav} setSelectedFav={setSelectedFav} favChanged={favChanged} setFavChanged={setFavChanged} refreshKey={favRefreshKey}/>
                ) : (
                  <DadosFavorecidoPf {...props} favs={favs} selectedFav={selectedFav} setSelectedFav={setSelectedFav} favChanged={favChanged} setFavChanged={setFavChanged} refreshKey={favRefreshKey}/>
                )}
              </div>

              {/* Coluna anexos + preview */}
              <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0, gap: 8 }}>
                <Typography sx={{ fontWeight: 700, fontSize: 13, color: '#0f172a' }}>
                  Anexos
                </Typography>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
                  {[
                    {
                      key: 'cob',
                      title: 'Cobrança',
                      icon: 'ri-receipt-line',
                      links: linkDocumentoDeCobranca,
                      files: documentoDeCobrancaFiles,
                      setFiles: setDocumentoDeCobrancaFiles,
                      disp: dispDocCobranca,
                      setDisp: setDispDocCobranca,
                      dispLabel: 'Dispensar',
                    },
                    {
                      key: 'nf',
                      title: 'Nota fiscal',
                      icon: 'ri-file-text-line',
                      links: linkNotaFiscal,
                      files: notaFiscalFiles,
                      setFiles: setNotaFiscalFiles,
                      disp: dispNF,
                      setDisp: setDispNF,
                      dispLabel: 'Dispensar',
                    },
                    {
                      key: 'comp',
                      title: 'Comprovante',
                      icon: 'ri-bank-card-line',
                      links: linkComprovante,
                      files: comprovantePagamentoFiles,
                      setFiles: setComprovantePagamentoFiles,
                      disp: null,
                      setDisp: null,
                      dispLabel: null,
                    },
                  ].map((slot) => {
                    // API pode devolver vários PDFs do mesmo tipo; listar todos (mais recente primeiro).
                    const savedPaths = Array.isArray(slot.links)
                      ? [...slot.links].filter(Boolean).reverse()
                      : []
                    const savedUrls = savedPaths.map((path) => getOikosFileUrl(path))
                    const pending = slot.files?.[0]?.props?.preview || null
                    const primaryUrl = pending || savedUrls[0] || null
                    const active = previewUrl && (
                      (pending && previewUrl === pending)
                      || savedUrls.includes(previewUrl)
                    )
                    return (
                      <div
                        key={slot.key}
                        style={{
                          border: active ? '1px solid #0f766e' : '1px solid #e2e8f0',
                          borderRadius: 8,
                          padding: 8,
                          background: active ? '#f0fdfa' : '#fff',
                          minHeight: 120,
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between mb-1">
                          <span style={{ fontSize: 11, fontWeight: 700 }}>
                            <i className={`${slot.icon} mr-1`} />
                            {slot.title}
                            {savedUrls.length > 1 ? (
                              <span style={{ fontWeight: 500, color: '#64748b' }}>
                                {` (${savedUrls.length})`}
                              </span>
                            ) : null}
                          </span>
                          {primaryUrl && (
                            <button
                              type="button"
                              className="btn btn-link btn-sm p-0"
                              style={{ fontSize: 11 }}
                              onClick={() => {
                                setPreviewUrl(primaryUrl)
                                setPreviewLabel(
                                  pending
                                    ? `${slot.title} (novo)`
                                    : savedUrls.length > 1
                                      ? `${slot.title} 1/${savedUrls.length}`
                                      : slot.title
                                )
                              }}
                            >
                              Ver
                            </button>
                          )}
                        </div>
                        {savedUrls.length > 0 && (
                          <ul
                            style={{
                              listStyle: 'none',
                              margin: '0 0 6px',
                              padding: 0,
                              maxHeight: 72,
                              overflowY: 'auto',
                            }}
                          >
                            {savedUrls.map((url, idx) => (
                              <li
                                key={`${slot.key}-saved-${idx}`}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  gap: 4,
                                  fontSize: 11,
                                  lineHeight: 1.3,
                                  padding: '2px 0',
                                  borderBottom: idx < savedUrls.length - 1 ? '1px solid #f1f5f9' : 'none',
                                }}
                              >
                                <span style={{ color: '#334155', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                  {`PDF ${idx + 1}`}
                                  {idx === 0 ? ' · atual' : ''}
                                </span>
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm p-0"
                                  style={{ fontSize: 11, flexShrink: 0 }}
                                  onClick={() => {
                                    setPreviewUrl(url)
                                    setPreviewLabel(`${slot.title} ${idx + 1}/${savedUrls.length}`)
                                  }}
                                >
                                  Ver
                                </button>
                              </li>
                            ))}
                          </ul>
                        )}
                        <AddFilesNoForm
                          multiple={false}
                          accept={['.pdf']}
                          files={slot.files}
                          onFilesChange={(files) => {
                            slot.setFiles(files)
                            const next = files?.[0]?.props?.preview
                            if (next) {
                              setPreviewUrl(next)
                              setPreviewLabel(`${slot.title} (novo)`)
                            }
                          }}
                        />
                        {slot.setDisp && (
                          <label style={{ fontSize: 11, marginTop: 4, marginBottom: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
                            <input
                              type="checkbox"
                              checked={!!slot.disp}
                              onChange={(e) => slot.setDisp(e.target.checked)}
                            />
                            {slot.dispLabel}
                          </label>
                        )}
                        {slot.key === 'comp' && Array.isArray(slot.links) && savedUrls.length === 0 && !pending && (
                          <button
                            type="button"
                            className="btn btn-link btn-sm p-0"
                            style={{ fontSize: 11, marginTop: 4, textAlign: 'left' }}
                            disabled={baixandoComprovante}
                            onClick={(e) => {
                              e.preventDefault();
                              baixarComprovanteKamino();
                            }}
                          >
                            {baixandoComprovante ? 'Obtendo...' : 'Obter Comprovante'}
                          </button>
                        )}
                      </div>
                    )
                  })}
                </div>

                <PdfPreviewPanel
                  url={previewUrl}
                  label={previewLabel}
                  onClose={() => { setPreviewUrl(null); setPreviewLabel('') }}
                  onCapture={(value) => handleChangeCodBarras({ target: { value } })}
                />
              </div>
            </div>
          </DialogContent>

          <DialogActions sx={{ px: 2.5, py: 1.5, borderTop: '1px solid #e5e7eb' }}>
            {isStatusLoading && (
              <Button
                autoFocus
                margin="dense"
                type="submit"
                variant="outlined"
                disabled
                endIcon={<Spinner/>}
              >Aguarde</Button>
            )}

            {!isStatusLoading && (
              <div className="d-flex justify-content-start" style={{ gap: 8 }}>
                <Button className="text-success" type="submit">
                  Enviar
                </Button>
                {!props.data.pend && (
                  <Button
                    className="text-success"
                    onClick={(e) => { e.preventDefault(); handleSendToBank(); }}
                  >
                    Enviar para o banco
                  </Button>
                )}
                <Button
                  onClick={async (e) => {
                    e.preventDefault();
                    handleClose()
                  }}
                >
                  Cancelar
                </Button>
              </div>
            )}
          </DialogActions>
        </Dialog>
      }
      <ModalOrcamentoExcedido
        open={openModal}
        onClose={handleCloseModal}
        onCadastrarPendente={cadastrarPendente}
        onAprovarCadastro={handleAprovarSuplementacao}
        isGestor={[1, 2, 3].includes(Number(props.user?.pf_id))}
        isLoadingCadastra={isLoadingCadastra}
        orcamentoInfoMes={orcamentoInfoMes}
        valor={valor}
        orcItemId={selectedOrcItem?.value}
        orcItemLabel={selectedOrcItem?.label}
        dataVenc={dataVenc}
        currentBdroId={props.data?.bdro_id}
        currentDesc={desc}
        currentFavLabel={selectedFav?.label}
        userPfId={props.user?.pf_id}
      />
      <Modal
        open={openErrorModal}
        onClose={handleCloseErrorModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Favor preencher todos os campos
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <p>Campos vazios:</p>
            {emptyValues.map((value, index) =>
              (
                <div key={index}>
                  <span>{convertValueToText(value)}</span>
                </div>
              )
            )}
          </Typography>
          <Button onClick={handleCloseErrorModal}>Voltar</Button>
        </Box>
      </Modal>
      <ModalConfirmacao
        openModal={clearKaminoOpen}
        isLoading={clearingKamino}
        onClosed={() => { if (!clearingKamino) setClearKaminoOpen(false); }}
        title="Limpar identificador Kamino"
        text="Isso remove o kamino_id deste borderô. O pagamento deixa de ficar vinculado à Kamino e poderá ser enviado de novo. Confirma?"
        confirmButtonText="Limpar kamino_id"
        confirmButtonColor="danger"
        onConfirm={handleClearKaminoId}
      />
    </>
  )
}

export default ModalEdicaoContaAPagar;
